import { atomWithKey as atom } from "./atomWithKey";
import { IFulfillmentResponse } from "../Types/Types/BookingTypes";


export const fulfillmentResponseAtom = atom<IFulfillmentResponse | null>({
  key: "fulfillmentResponseAtom",
  default: null,
});
